import React from "react";

const SOCCER_BALL = `${import.meta.env.BASE_URL}assets/img/balls/soccer-ball.png`;

/**
 * Reference result body for Goal: rdesc "player#method".
 * winnat "No Goal" → desc[0], otherwise "{method} by {player}".
 */
export default function GoalResultBody({ t1 }) {
  const desc = String(t1?.rdesc || "").split("#");
  return (
    <div className="d-flex justify-content-center">
      <div className="cricket20ballpopup cricket20ballresult goalresult">
        <img src={SOCCER_BALL} alt="" />{" "}
        {t1?.winnat === "No Goal" ? <span>{desc[0]}</span> : <span>{`${desc[1]} by ${desc[0]}`}</span>}
      </div>
    </div>
  );
}
